import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        Peak has worked to understand how it could use AI to help FareShare GM operate more
        efficiently, even during times of peak demand. As Danger noted, one of the main logistical
        challenges that FareShare faces is a forecasting problem. Each day’s operations have so many
        variables, including how much donated food will arrive from how many different partners,
        what types of food the donations will include, and what sort of needs each of their
        community food members will have on that day.
      </p>
      <p className="chapter__paragraph">
        Essentially, the FareShare GM team wants to have a better idea of what donations to expect
        on any given day and what the specific emergency food needs are in their community at any
        given time. “Having this ability would enable us to be more efficient by smoothing out the
        process of getting food donations allocated and into the community,” Danger says.
        “Basically, we would be able to support a heck of a lot more people with much more food.”
      </p>
    </section>
  );
}

export default Chapter4;
